import { Component, Vue, Prop } from "vue-property-decorator";

import template from "./template.vue";

import { ImageEditor } from "../image_editor/ImageEditor";
import { HttpService } from "../../../services/HttpService";
import {FileImageEdit} from "../../../interfaces/FileImageEdit"

@Component({
  name: "ImageEditorModule",
  mixins: [template],
  components: {
    ImageEditor,
  },
})
export class ImageEditorModule extends Vue {
  @Prop({ required: true }) imageSrc!: string;
  @Prop({ required: true }) fileId!: number;
  @Prop() fileEditId?: number;

  settings = {
    aspectRatio: 3/2,
    width: 450,
    height: 250,
    left: 300,
    top: 100,
    rotation: 180,
  };

  loaded = false;

  _fileEditId?: number

  async created() {
    /* wenn editImage -> dann die settings laden */
    this._fileEditId = this.fileEditId
    if (this._fileEditId) {
      try {
        const resp = await HttpService.instance.get<FileImageEdit>(
          `${APP_API_URL}bbprofile/v1/de/fileImageEdit/${this._fileEditId}`
        );
        if (!resp.body) throw Error("settings not found");
        const { ratio, crop_width, crop_height, crop_x, crop_y, rotation } =
          resp.body;
        this.settings = {
          aspectRatio: ratio,
          width: crop_width,
          height: crop_height,
          left: crop_x,
          top: crop_y,
          rotation,
        };
      } catch (error) {
        throw error;
      }
    }

    this.loaded = true;
  }

  async save() {
    const data = {
      file_id: this.fileId,
      ratio: this.settings.aspectRatio,
      crop_x: this.settings.left,
      crop_y: this.settings.top,
      crop_width: this.settings.width,
      crop_height: this.settings.height,
      rotation: this.settings.rotation,
      focus_x: 0,
      focus_y: 0,
    };

    if (this._fileEditId) {
      try {
        await HttpService.instance.put<FileImageEdit>(
          `${APP_API_URL}bbprofile/v1/de/fileImageEdit/${this._fileEditId}`,
          data
        );
      } catch (error) {
        throw error;
      }
    } else {
      try {
        const response = await HttpService.instance.post<FileImageEdit>(
          `${APP_API_URL}bbprofile/v1/de/fileImageEdit`,
          data
        );

        if (response.body) this._fileEditId = response.body.id!;
      } catch (error) {
        throw error;
      }
    }
  }

  async saveAndClose(){
    await this.save()
    this.$emit("close")
  }

  async close(){
    await this.save()
    this.$emit("close")
  }
}
